import { render, staticRenderFns } from "./FullOferta.vue?vue&type=template&id=5c775fba&scoped=true&"
import script from "./FullOferta.vue?vue&type=script&lang=js&"
export * from "./FullOferta.vue?vue&type=script&lang=js&"
import style0 from "./FullOferta.vue?vue&type=style&index=0&id=5c775fba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c775fba",
  null
  
)

export default component.exports